export type CompatVerdict = "supported" | "unsupported";

export function evaluateCompat(os: string, version: string): CompatVerdict {
  const lower = os.toLowerCase();
  if (lower !== "ios" && lower !== "android") return "unsupported";
  const major = parseInt((version || "").split(".")[0], 10);
  if (Number.isNaN(major)) return "unsupported";
  if (lower === "ios") return major < 18 ? "unsupported" : "supported";
  return major <= 13 ? "unsupported" : "supported";
}
